// extracted by mini-css-extract-plugin
export default {"max-width-mobile":"575px","min-width-tablet":"576px","max-width-tablet":"991px","min-width-desktop":"992px"};